import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserAuth } from '../context/UserAuthContext';
import {
  Box,
  Container,
  Typography,
  Button,
  AppBar,
  Toolbar,
  IconButton
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const Fun = () => {
  const navigate = useNavigate();
  const { userData } = useUserAuth();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 30%, #2a2a2a 70%, #1a1a1a 100%)'
      }}
    >
      {/* Header */}
      <AppBar
        position="static"
        sx={{
          background: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.3)'
        }}
      >
        <Toolbar>
          <IconButton
            onClick={() => navigate('/user-dashboard')}
            sx={{
              color: '#FF6B35',
              mr: 1,
              '&:hover': {
                background: 'rgba(255, 107, 53, 0.1)'
              }
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <MenuBookIcon sx={{ color: '#FF6B35', mr: 2, fontSize: 32 }} />
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              fontWeight: 700,
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            YoungPresso
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: { xs: 4, sm: 6, md: 8 } }}>
        <Box
          sx={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              width: { xs: 120, sm: 150, md: 180 },
              height: { xs: 120, sm: 150, md: 180 },
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #4CAF50 0%, #81C784 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 32px rgba(76, 175, 80, 0.3)',
              animation: 'bounce 2s ease-in-out infinite',
              '@keyframes bounce': {
                '0%, 100%': {
                  transform: 'translateY(0px) scale(1)'
                },
                '50%': {
                  transform: 'translateY(-15px) scale(1.05)'
                }
              }
            }}
          >
            <EmojiEmotionsIcon
              sx={{
                fontSize: { xs: 60, sm: 75, md: 90 },
                color: 'white'
              }}
            />
          </Box>

          {/* Title */}
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              background: 'linear-gradient(45deg, #4CAF50 30%, #81C784 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              mb: 2
            }}
          >
            Fun Zone
          </Typography>

          {/* Coming Soon Message */}
          <Typography
            variant="h5"
            sx={{
              color: 'rgba(255, 255, 255, 0.9)',
              fontWeight: 600,
              fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
              mb: 1
            }}
          >
            Coming Soon! 🎉
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' },
              maxWidth: 600,
              lineHeight: 1.8
            }}
          >
            Get ready for games, puzzles, interactive activities, and so much more! 
            We're creating an exciting fun zone where learning meets entertainment.
          </Typography>

          {/* Back Button */}
          <Button
            variant="contained"
            onClick={() => navigate('/user-dashboard')}
            sx={{
              mt: 2,
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              color: 'white',
              fontWeight: 700,
              px: { xs: 3, sm: 4, md: 5 },
              py: { xs: 1.2, sm: 1.5, md: 1.8 },
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
              borderRadius: 3,
              '&:hover': {
                background: 'linear-gradient(45deg, #FF8C35 30%, #FFC74D 70%)',
                transform: 'scale(1.05)',
                boxShadow: '0 6px 20px rgba(255, 107, 53, 0.5)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            Back to Dashboard
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Fun;
